<div *nzModalTitle class="px-0 py-1 w-full grid grid-cols-2 gap-4 place-content-evenly">
	<div style="display: flex; align-items: center;">
		<p class="modal-title">{{data.nzTitle}}</p>
	</div>
</div>

<div class="mx-4 flex flex-col h-full overflow-x-hidden overflow-y-auto">
	@if (isLoading) {
	    <app-loader></app-loader>
	}
	@else{
		<form nz-form [nzLayout]="'vertical'" [formGroup]="validateForm">
			<div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }" class="p-4">
                <nz-form-item nz-col nzXs="24" nzSm="12" nzMd="12" class="px-4">
                    <nz-form-label>
                        Familias
                    </nz-form-label>
                    <nz-form-control>
                        <nz-select [nzMaxTagCount]="2" [nzMaxTagPlaceholder]="tagPlaceHolder" nzMode="multiple"
                            nzPlaceHolder="Seleccione una o más familias de artículo"
                            [(ngModel)]="articleFamiliesSelected" formControlName="familiesIds" name="familiesIds">
                            @for (f of articleFamilies; track f.id) {
                                <nz-option [nzLabel]="f.name" [nzValue]="f.id"></nz-option>
                            }
                        </nz-select>
                        <ng-template #tagPlaceHolder let-selectedList>y {{ selectedList.length }} más
                            seleccionados</ng-template>
                    </nz-form-control>
                </nz-form-item>
				<nz-form-item nz-col [nzXs]="24" [nzSm]="12" [nzMd]="12" class="px-4">
					<nz-form-label>
						Artículo
					</nz-form-label>
                    <nz-form-control>
						<input onfocus="select()" formControlName="article" nz-input
							placeholder="Introduce un artículo a filtrar" />
					</nz-form-control>
				</nz-form-item>
				<nz-form-item nz-col nzXs="24" nzSm="12" nzMd="6" class="px-4">
					<nz-form-label>
						Lote
					</nz-form-label>
					<nz-form-control>
						<input onfocus="select()" formControlName="articleBatch" nz-input
							placeholder="Introduce un lote a filtrar" />
					</nz-form-control>
				</nz-form-item>

                <nz-form-item nz-col nzXs="24" nzSm="12" nzMd="6" class="px-4">
					<nz-form-label>
						Número de formato
					</nz-form-label>
					<nz-form-control>
						<input onfocus="select()" formControlName="packagingBatch" nz-input
							placeholder="Introduce número de formato a filtrar" />
					</nz-form-control>
				</nz-form-item>

                <nz-form-item nz-col nzXs="24" nzSm="12" nzMd="6" class="px-4">
                    <nz-form-label>
					</nz-form-label>
                    <nz-form-control>
                        <button nz-button (click)="search()" class="button primary-button" [nzLoading]="isSearching || isSaving">
                            Buscar
                        </button>
                    </nz-form-control>
				</nz-form-item>
			</div>
		</form>
        <nz-divider nzText="Resultados"></nz-divider>
        <div class="flex-1">
            @if (articles && articles.length > 0) {
                <nz-table
                    #basicTable
                    [nzData]="articles"
                    class="m-0 p-0"
                    nzSize="small"
                    [nzLoading]="isSearching || isSaving"
                    nzTableLayout="auto"
                    [nzBordered]="true"
                    [nzFrontPagination]="false"
                    [nzShowPagination]="false"
                    [nzScroll]="{ y: '200px' }"
                    [nzLoadingIndicator]="indicatorTemplate"
                    >
                    <thead>
                    <tr>
                        <th id="article">Artículo</th>
                        <th id="batch">Lote</th>
                        <th id="packaging">Formato</th>
                        <th id="actions">Acciones</th>
                    </tr>
                    </thead>
                    <tbody>
                    @for (article of basicTable.data; track article; let idx = $index) {
                        <tr>
                            <td>
                                {{ article.name }}
                            </td>
                            <td>
                                {{ article.batch ?? '-' }}
                            </td>
                            <td>
                                {{ article.packagingBatch ?? '-'}}
                            </td>
                            <td>
                                <div class="flex align-middle justify-center">
                                    <button nz-button (click)="selectArticle(article)" class="button primary-button">
                                        Seleccionar
                                    </button>
                                </div>
                            </td> 
                        </tr>    
                    }
                    </tbody>
                </nz-table>
            }
            @else {
                <!-- TODO: change empty data by loader when table data is loading -->
                <div class="w-full h-full content-center">
                    <nz-empty></nz-empty>
                </div>
            }
        </div>
	}
</div>

<ng-template #indicatorTemplate>
    <app-loader></app-loader>
</ng-template>

<div *nzModalFooter>
	<div class="flex justify-end">
		<button (click)="handleCancel()" class="button secondary-button mr-2">
			Cancelar
		</button>
	</div>
</div>
